// extracted by mini-css-extract-plugin
module.exports = {"content":"content-10Wfjt0r","space20":"space20-3nm2phCM"};